import { Kind, Links } from "../base";

export type QueryTermOp = "=" | ">" | ">=" | "<" | "<=" | "!=" | "exists" | "!exists" | "~" | "=~";
export interface QueryTerm {
  op: QueryTermOp;
  property?: string;
  rel?: string;
  tag?: string;
  value?: string | boolean;
}

export type QuerySortOrder = "asc" | "desc";
export interface QuerySort {
  by: string;
  order: QuerySortOrder;
}

export type QuerySpecMatch = "all" | "any" | "none";
export interface QuerySpec {
  match: QuerySpecMatch;
  terms: QueryTerm[];
  sort?: QuerySort;
}

export interface Query {
  kind?: Kind;
  // context: any,
  // fetch: 'links' | 'items',
  spec: QuerySpec;
}

export interface QueryResult<T> {
  kind: "queryresult";
  itemKind: Kind;
  items: T[];
  query: Query;
  links: Links;
}

export function fuzzySearchQuery(kind: string, search: string) {
  return {
    kind,
    spec: {
      match: "any",
      terms: [
        {
          op: "~",
          property: "*",
          value: search,
        },
        {
          op: "~",
          tag: "*",
          value: search,
        },
      ],
    },
  };
}

export interface FilterTerm {
  property?: string;
  rel?: string;
  value: string;
}
export function kindQuery(kind: string, filters: FilterTerm[], filter?: string) {
  const terms = filters.map((f) => {
    if (f.property) {
      return { op: "=", property: f.property, value: f.value };
    }
    return { op: "=", rel: f.rel, value: f.value };
  });
  if (filter) {
    terms.push({
      op: "~",
      property: "*",
      value: filter,
    });
  }
  return {
    kind,
    spec: {
      match: "all",
      terms,
    },
  };
}
